import { useLayoutEffect } from 'react';
import tailwindTheme from '../tailwind/theme';
import { generateAndAppendVariableStyles, removeOldVariableStyles } from '../tailwind/_variables/general';
import { IThemeEntity, Theme, Themes } from '../tailwind/types';

interface IWindowWithTailwind extends Window {
  tailwind?: {
    config: {
      theme: typeof tailwindTheme;
    };
  };
}

function useStorybookTailwind({ dataTheme, themes }: { dataTheme: Themes; themes: IThemeEntity }) {
  useLayoutEffect(() => {
    const head = document.getElementsByTagName('head')[0];
    const cdnScript = document.createElement('script');
    cdnScript.src = 'https://cdn.tailwindcss.com?v=3.4.17';
    cdnScript.async = true;

    cdnScript.onload = () => {
      const win = window as IWindowWithTailwind;
      if (win.tailwind) {
        win.tailwind.config = { theme: structuredClone(tailwindTheme) };
      } else {
        console.error('Tailwind object not found');
      }
    };

    head.appendChild(cdnScript);
  }, []);

  useLayoutEffect(() => {
    if (dataTheme) {
      removeOldVariableStyles();
      generateAndAppendVariableStyles(document.head, dataTheme, { [dataTheme]: themes });
    }
  }, [dataTheme, themes]);
}

export default function useStorybookTailwindWithInterceptor({ dataTheme, themes }: { dataTheme: unknown; themes: unknown }) {
  useStorybookTailwind({ dataTheme: dataTheme ? (dataTheme as Themes) : Theme.light, themes: themes as IThemeEntity });
}
